import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

export const AddImage = async (name, type, image, user_id, token) => {
  try {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("type", type);
    formData.append("image", image);

    const response = await axios.post(`${BASE_URL}/image/addImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        user_id: user_id,
        token: token,
      },
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const RemoveImage = async (file_key, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/image/removeImage`,
      { fileKey: file_key },
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetAllCustomersByStoreSummary = async (
  store_id,
  user_id,
  token
) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/GetAllCustomersByStoreSummary`,
      { store_id: store_id },
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetSaleOverview = async (store_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getSaleOverview`,
      { store_id: store_id },
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetOverviewAccounts = async (store_id, range, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getOverviewAccounts`,
      { store_id: store_id, range: range },
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetOverviewCounts = async (store_id, user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getOverviewCounts`,
      { store_id: store_id },
      { headers: { user_id: user_id, token: token } }
    );
    //console.log(response);
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetNumSO = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getNumSO`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetNumPO = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getNumPO`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetNumOpenSO = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getNumOpenSO`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetNumOpenPO = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getNumOpenPO`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetSaleRevByMonth = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getSaleRevByMonth`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const GetPurchCostByMonth = async (user_id, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/overview/getPurchCostByMonth`,
      {},
      { headers: { user_id: user_id, token: token } }
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};
